<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {}
    },
    methods: {
        getDomin() {
            var domain = document.domain
            this.$axios
                .get(
                    this.$managePath +
                        '/offline/api/getPlatform?domain=' +
                        domain
                )
                .then(res => {
                    var data = res.data.data.id
                    localStorage.setItem('datas', data)
                    this.$store.commit('setPlatform', res.data.data)
                    // 获取注册项
                    this.$axios
                        .get(
                            this.$managePath +
                                '/offline/api/registrationItem?platformId=' +
                                data
                        )
                        .then(res => {
                            if (res.data.status == 1) {
                                localStorage.setItem(
                                    'registrationItems',
                                    JSON.stringify(res.data.data)
                                )
                            }
                        })
                    // 获取平台状态
                    this.$axios
                        .get(
                            this.$managePath +
                                '/offline/api/platformStatus?platformId=' +
                                data
                        )
                        .then(res => {
                            let data = res.data.data.allowRegister
                            let maintain = res.data.data.maintain
                            localStorage.setItem('allowRegister', data)
                            localStorage.setItem('maintain', maintain)
                        })
                })
        }
    },
    created() {
        this.getDomin()
    }
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0;
}
.el-scrollbar__wrap {
    margin-bottom: 0 !important;
    overflow-x: hidden !important;
}
body {
    margin: 0;
}

/* 下面是级联下拉框 选择任意节点时的样式 */
.el-cascader-panel .el-radio {
    width: 100%;
    height: 100%;
    z-index: 10;
    position: absolute;
    top: 10px;
    right: 10px;
}

.el-cascader-panel .el-radio__input {
    visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue